import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from "rxjs";
import { user } from "../models/user";
import { auth_server, auth_server_sso } from "../../assets/conf_urls.json";

@Injectable({ providedIn: 'root' })
export class AdminService {
  updatedUserID = new BehaviorSubject(null);
  private token = null;

  /**
   class to manage creating/ editing / deleting users in the application.
   */
  constructor(private http: HttpClient) {
    this.token = localStorage.getItem('accessToken');
  }

  getUsers(): Observable<user[]> {
    this.token = localStorage.getItem('accessToken');
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.token, responseType: 'text' });
    return this.http.get<user[]>(auth_server_sso.getAll, { headers });
  }

  getById(id: number): Observable<user> {
    if (id) {
      const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.token, responseType: 'text' });
      return this.http.post<user>(auth_server_sso.getById, { id: id }, { headers });
    } else {
      return null;
    }
  }

  deleteUser(userId: number): Observable<any> {
    if (userId) {
      const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.token, responseType: 'text' });
      return this.http.post<any>(auth_server_sso.delete, {
        id: userId
      }, { headers });
    } else {
      return null;
    }
  }

  postUser(user: user): Observable<user> {
    if (user) {
      const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.token, responseType: 'text' });
      return this.http.post<user>(auth_server_sso.create, {
        user_upn: user.user_upn,
        user_email: user.user_upn,
        user_role: user.user_role
      }, { headers });
    } else {
      return null;
    }
  }

  updateUser(user: user): Observable<any> {
    if (user) {
      const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.token, responseType: 'text' });
      const returnedData = this.http.post<any>(auth_server_sso.update, {
        id: user.id,
        user_upn: user.user_upn,
        user_email: user.user_upn,
        user_role: user.user_role
      }, { headers });
      return returnedData;
    } else {
      return null;
    }
  }

  updateUserActivationStatus(user: user): Observable<any> {
    if (user) {
      const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.token, responseType: 'text' });
      const returnedData = this.http.post<any>(auth_server_sso.update, {
        id: user.id,
        is_active: user.is_active
      }, { headers });
      return returnedData;
    } else {
      return null;
    }
  }

}




//this is the old code

// import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { Injectable } from '@angular/core';
// import { BehaviorSubject } from 'rxjs';
// import { Observable } from "rxjs";
// import { user } from "../models/user";
// import { auth_server } from "../../assets/conf_urls.json";

// @Injectable({ providedIn: 'root' })
// export class AdminService {
//   updatedUserID = new BehaviorSubject(null);
//   private token = localStorage.getItem('accessToken');

//   /**
//    class to manage creating/ editing / deleting users in the application.
//    */
//   constructor(private http: HttpClient) {
//   }

//   getUsers(): Observable<user[]> {
//     this.token = localStorage.getItem('accessToken');
//     const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.token, responseType: 'text' });
//     return this.http.get<user[]>(auth_server.getAll, { headers });
//   }

//   getById(id: number): Observable<user> {
//     if (id) {
//       const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.token, responseType: 'text' });
//       return this.http.post<user>(auth_server.getById, { id: id }, { headers });
//     } else {
//       return null;
//     }
//   }

//   deleteUser(userId: number): Observable<any> {
//     if (userId) {
//       const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.token, responseType: 'text' });
//       return this.http.post<any>(auth_server.delete, {
//         id: userId
//       }, { headers });
//     } else {
//       return null;
//     }
//   }

//   postUser(user: user, password: string, folderArr: number[]): Observable<user> {
//     if (user) {
//       const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.token, responseType: 'text' });
//       return this.http.post<user>(auth_server.create, {
//         user_email: user.user_email,
//         user_password: password,
//         user_role: user.user_role,
//         email_address: user.email_address,
//         is_active: user.is_active,
//         folders: folderArr
//       }, { headers });
//     } else {
//       return null;
//     }
//   }

//   updateUser(user: user): Observable<any> {
//     if (user) {
//       const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.token, responseType: 'text' });
//       const returnedData = this.http.post<any>(auth_server.update, {
//         id: user.id,
//         user_email: user.user_email,
//         user_role: user.user_role,
//         email_address: user.email_address,
//         is_active: user.is_active
//         //user_enabled logic
//       }, { headers });
//       return returnedData;
//     } else {
//       return null;
//     }
//   }


//   resetUserPassword(id: number, password: string): Observable<any> {
//     const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.token, responseType: 'text' });
//     return this.http.post<any>(auth_server.update, {
//       id: id,
//       user_password: password
//     }, { headers });
//   }

//   updatePasswordByToken(newPassword: string): Observable<any> {
//     const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.token, responseType: 'text' });
//     return this.http.post<any>(auth_server.updateByToken, {
//       user_password: newPassword
//     }, { headers });
//   }

// }
